import { render } from "./ContextMenuMessage.vue?vue&type=template&id=366acfd7&scoped=true"
import script from "./ContextMenuMessage.vue?vue&type=script&lang=js"
export * from "./ContextMenuMessage.vue?vue&type=script&lang=js"

import "./ContextMenuMessage.vue?vue&type=style&index=0&id=366acfd7&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366acfd7"]])

export default __exports__